import gql from "graphql-tag";

export const EXPENSE_TYPES = gql`
  query expenseTypes {
    expenseTypes {
      id
      name
    }
  }
`;

export const EXPENSES = gql`
  query FilterWithPaginateExpenses($criteria: ExpenseFilterCriteria!, $pagination: Pagination!) {
    filterWithPaginateExpenses(criteria: $criteria, pagination: $pagination) {
      content {
        id
        name
        description
        type {
          id
          name
        }
        employee {
          id
          firstName
          lastName
          profile {
            imageUrl
          }
        }
        reporter {
          id
          firstName
          lastName
        }
        requested {
          amount
          code
        }
        timestamp
        attachment
        requestStatus
        description
        travel {
          id
          beginDate
          endDate
          startWorkDate
          employee {
            id
            firstName
            lastName
            profile {
              imageUrl
            }
            employment {
              branch {
                name
              }
            }
          }
          address
          country
          city
          region
          requestStatus
        }
        expenseManagement {
          id
          name
          project {
            name
            color
          }
          employee {
            id
            firstName
            lastName
            profile {
              imageUrl
            }
            employment {
              branch {
                name
              }
            }
          }
        }
      }
      pageInfo {
        totalElements
      }
    }
  }
`;
